// Enkel event-bus för hjälpsystemet
export const HELP_EVENTS = {
  OPEN_DIALOG: "bytajobb:open-help",
  START_TOUR: "bytajobb:start-tour",
} as const;

export function openHelpDialog(tab: "kom-igang" | "faq" | "ai" = "kom-igang") {
  window.dispatchEvent(new CustomEvent(HELP_EVENTS.OPEN_DIALOG, { detail: { tab } }));
}

export function startHelpTour() {
  window.dispatchEvent(new CustomEvent(HELP_EVENTS.START_TOUR));
}
